module.exports = __webpack_public_path__ + "static/media/javascript.faf3923c.png";